import { lazyLoad } from 'utils/loadable';

export const SupplierSegmentListPage = lazyLoad(
  () => import('./index'),
  module => module.SupplierSegmentListPage
);
